<template>
    <div>
        <v-row no-gutters v-if="showWelcome">
            <v-col cols="12">
                <welcome :show-retry-btn="showRetryBtn" :loading="loadingFinish" @continue="onFinish" @retry="onRetry"/>
            </v-col>
        </v-row>
        <auth-layout v-else align-top>
            <loading-spinner v-if="!component" />
            <component v-else :is="component" @finish="onFinishStepper"/>
        </auth-layout>

        <welcome-invitation-dialog ref="invitation" :invitation="pendingInvitation" @done="goHome" />
    </div>
</template>

<script>

import BasicInfoStudent from '@/components/student/BasicInfoStepper'
import BasicInfoCoach from '@/components/coach/BasicInfoStepper'
import BasicInfoCompany from '@/components/company/BasicInfoStepper'
import Welcome from '@/components/entrance/Welcome'
import AuthLayout from '@/components/entrance/AuthLayout'

import {db} from "@/utils/Firebase";
import {getCoachClientsLimit} from "@/utils/Helpers";
import LoadingSpinner from "@/components/common/LoadingSpinner";
import WelcomeInvitationDialog from "@/components/student/WelcomeInvitationDialog";
import {mapActions} from "vuex";

export default {
    components: {
        LoadingSpinner,
        BasicInfoStudent,
        BasicInfoCoach,
        BasicInfoCompany,
        Welcome,
        AuthLayout,
        WelcomeInvitationDialog,
    },
    data() {
        return {
            showWelcome: false,
            loadingFinish: false,
            showRetryBtn: false,
            pendingInvitation: null,
        }
    },
    computed: {
        component(vm = this) {
            switch (vm.account?.accountType) {
                case 'student':
                    return 'BasicInfoStudent'
                case 'coach':
                    return 'BasicInfoCoach'
                case 'company':
                    return 'BasicInfoCompany'
                default:
                    return null
            }
        }
    },
    methods: {
        ...mapActions(['bindUserAccount']),
        onFinishStepper() {
            const vm = this
            vm.showWelcome = true
        },
        async onFinish() {
            const vm = this
            vm.loadingFinish = true

            try {
                await vm.bindUserAccount(vm.currentUser)
                await vm.waitForAccountName()
                if (vm.accountType === 'student' && await vm.loadPendingInvitation()) {
                    return vm.$refs.invitation.show()
                }
            } catch (err) {
                console.log('onFinish error:', err && err.message)
            }

            await vm.goHome()
        },
        async loadPendingInvitation() {
            const vm = this
            try {
                const studentInvitationsRef = await db.collection('studentInvitations')
                    .where('studentEmail', '==', vm.currentUser.email)
                    .where('status', '==', 'pending')
                    .orderBy('createdAt', 'desc')
                    .limit(1)
                    .get()

                const invitation = studentInvitationsRef.docs[0]
                if (!invitation) return false

                const coachId = invitation.data()?.coach?.id || null
                const { canInvite } = await getCoachClientsLimit(coachId)
                if (!canInvite) return false

                vm.pendingInvitation = {id: invitation.id, ...invitation.data()}
                return true
            } catch (err) {
                console.log('pending invitation error:', err && err.message)
                return false
            }
        },
        waitForAccountName(timeout = 5000) {
            const vm = this
            return new Promise(resolve => {
                const start = Date.now()
                const check = () => {
                    if ((vm.account && vm.account.name) || (Date.now() - start) >= timeout) return resolve()
                    setTimeout(check, 100)
                }
                check()
            })
        },
        async goHome() {
            const vm = this
            try {
                await vm.$router.push({name: `${vm.accountType}.home`, replace: true})
            } catch (err) {
                console.log('navigation error:', err && err.message)
                vm.showRetryBtn = true
                vm.loadingFinish = false
            }
        },
        onRetry() {
            const vm = this
            vm.showRetryBtn = false
            vm.loadingFinish = true
            vm.goHome()
        },
    },
}
</script>
